import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, Music2, Twitter, Linkedin, MessageCircle } from "lucide-react";
import { useI18n } from "../context/I18nContext";
import { api } from "../lib/api";

const SOCIAL_ICONS = {
  facebook: { Icon: Facebook, hover: "hover:text-[#0052CC]", label: "Facebook" },
  instagram: { Icon: Instagram, hover: "hover:text-[#E1306C]", label: "Instagram" },
  tiktok: { Icon: Music2, hover: "hover:text-[#EE1D52]", label: "TikTok" },
  youtube: { Icon: Youtube, hover: "hover:text-[#FF0000]", label: "YouTube" },
  whatsapp: { Icon: MessageCircle, hover: "hover:text-[#25D366]", label: "WhatsApp" },
  twitter: { Icon: Twitter, hover: "hover:text-[#1DA1F2]", label: "Twitter" },
  linkedin: { Icon: Linkedin, hover: "hover:text-[#0A66C2]", label: "LinkedIn" },
};

export default function Footer() {
  const { t } = useI18n();
  const [social, setSocial] = useState({});

  useEffect(() => {
    api.get("/social-links").then(({ data }) => setSocial(data || {})).catch(() => {});
  }, []);

  const socialEntries = Object.entries(SOCIAL_ICONS).filter(([k]) => social[k]);

  return (
    <footer className="bg-[#0a1430] text-white mt-24" data-testid="site-footer">
      <div className="je-container py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <h4 className="font-bold text-lg mb-3" style={{fontFamily: "Outfit"}}>John Elektwo</h4>
          <p className="text-sm text-white/70">{t("ourStore")}</p>
          <div className="flex gap-3 mt-4" data-testid="footer-social">
            {socialEntries.length === 0 ? (
              <p className="text-xs text-white/40">Aucun réseau configuré</p>
            ) : socialEntries.map(([k, { Icon, hover, label }]) => (
              <a
                key={k}
                href={social[k]}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={label}
                data-testid={`footer-social-${k}`}
                className={`transition ${hover}`}
              >
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h5 className="font-semibold mb-3">{t("pages")}</h5>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about">{t("aboutUs")}</Link></li>
            <li><Link to="/contact">{t("contactUs")}</Link></li>
            <li><Link to="/help">{t("helpCenter")}</Link></li>
            <li><Link to="/security">{t("securityCenter")}</Link></li>
            <li><Link to="/partner">{t("becomePartner")}</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="font-semibold mb-3">{t("info")}</h5>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/info/livraison">{t("shippingInfo")}</Link></li>
            <li><Link to="/info/retour">{t("returnPolicy")}</Link></li>
            <li><Link to="/info/signaler">{t("reportSuspicious")}</Link></li>
            <li><Link to="/track">{t("trackingOrder")}</Link></li>
            <li><Link to="/account">{t("myAccountFooter")}</Link></li>
          </ul>
        </div>
        <div>
          <h5 className="font-semibold mb-3">{t("contact")}</h5>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Gonaïves, Haïti</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> +509 32190716</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0" /> Contact@johnelektwo.com</li>
            {social.whatsapp && (
              <li><a href={social.whatsapp} target="_blank" rel="noreferrer noopener" className="text-[#25D366] hover:underline">WhatsApp</a></li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} JOHN ELEKTWO • {t("allRightsReserved")}
      </div>
    </footer>
  );
}
